// import Link from 'next/link';
import React from 'react'
import {ChevronLeftIcon} from "@heroicons/react/24/solid";
import {Link} from "react-router-dom";

const ShowLink = ({label, url}) => {

    return (
        <>
            <Link to={url}>
                <div
                    className="cursor-pointer rounded flex items-center justify-center border border-gray-300 bg-white text-gray-600 py-1 px-2 hover:bg-gray-600 hover:border-gray-600 hover:text-white">
                    <div className="">
                        <ChevronLeftIcon className="h-6"/>
                    </div>
                    <span className="mr-2">{label}</span>
                </div>
            </Link>
        </>
    )
}

export default ShowLink
